import(/* webpackMode: "eager" */ "/app/components/accommodation-detail/AccommodationAllAmenitiesDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccommodationBooking"] */ "/app/components/accommodation-detail/AccommodationBooking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccommodationHost"] */ "/app/components/accommodation-detail/AccommodationHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccommodationImages"] */ "/app/components/accommodation-detail/AccommodationImages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccommodationInfoShortcuts"] */ "/app/components/accommodation-detail/AccommodationInfoShortcuts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccommodationPrices"] */ "/app/components/accommodation-detail/AccommodationPrices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingPopover"] */ "/app/components/accommodation-detail/BookingPopover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpBaseCapacity"] */ "/app/components/accommodation-detail/PdpBaseCapacity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpPricesTabCount"] */ "/app/components/accommodation-detail/PdpPricesTabCount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareBtn"] */ "/app/components/accommodation-detail/ShareBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/HomeCarouselSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoTooltip"] */ "/app/components/shared/InfoTooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomLink"] */ "/app/components/ui/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/app/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/image-component.js");
